/* MT-CRO: small enhancements. No dependencies. */
(function () {
  /* 1. Hide broken images inside Judge.me widgets (deleted products leave dead thumbnails) */
  function hideIfBroken(img) {
    if (!img || img.tagName !== 'IMG') return;
    if (!img.closest('[class*="jdgm"]')) return;
    var holder = img.closest('.jdgm-carousel-item__product, .jdgm-rev__prod-link-prefix, .jdgm-rev__pic-link') || img;
    holder.style.display = 'none';
  }
  document.addEventListener('error', function (e) { hideIfBroken(e.target); }, true);
  function sweep() {
    document.querySelectorAll('[class*="jdgm"] img').forEach(function (img) {
      if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) hideIfBroken(img);
    });
  }
  window.addEventListener('load', function () { sweep(); setTimeout(sweep, 3000); });

  /* 2. Product page: collapse very long descriptions behind a "Read full description" button */
  function collapseDescription() {
    var info = document.getElementById('product--page');
    if (!info) return;
    var tab = info.querySelector('.product--tab__content');
    if (!tab || tab.dataset.mtCollapsed) return;
    var limit = 520;
    if (tab.scrollHeight < limit + 200) return;
    tab.dataset.mtCollapsed = '1';
    tab.classList.add('mt-collapse');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mt-collapse__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read full description';
    btn.addEventListener('click', function () {
      var open = tab.classList.toggle('mt-collapse--open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read full description';
      if (!open) tab.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    tab.insertAdjacentElement('afterend', btn);
    /* MT-SEO: only show the button while the Description tab is the open one */
    function syncBtn() { btn.style.display = tab.classList.contains('tab--show') ? '' : 'none'; }
    syncBtn();
    if (window.MutationObserver) new MutationObserver(syncBtn).observe(tab, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collapseDescription);
  else collapseDescription();

  /* 2b. MT-SEO: keep the tab area height steady when switching tabs, so the sticky gallery does not jump */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.tab--product');
    if (t) {
      var box = t.closest('.tab__container--product');
      if (box) box.style.minHeight = Math.max(box.offsetHeight, parseFloat(box.style.minHeight) || 0) + 'px';
      return;
    }
    /* collapsing or expanding the description changes its real height, so release the lock */
    var b = e.target.closest && e.target.closest('.mt-collapse__btn');
    if (b) { var c = b.closest('.tab__container--product'); if (c) c.style.minHeight = ''; }
  }, true);
  window.addEventListener('resize', function () {
    document.querySelectorAll('.tab__container--product').forEach(function (c) { c.style.minHeight = ''; });
  });

  /* 3. Product page: sticky Add to cart only after the main button has scrolled past */
  function initStickyGate() {
    var info = document.getElementById('product--page');
    if (!info) return;
    var atc = info.querySelector('.product__atc .button--addToCart') || info.querySelector('.product__atc');
    if (!atc) return;
    document.body.classList.add('mt-sticky-gated');
    var ticking = false;
    function check() {
      ticking = false;
      var r = atc.getBoundingClientRect();
      /* Desktop: only once the main button has scrolled past.
         Mobile: whenever the main button is off screen, above or below, so a buy button is always in reach. */
      var mobile = window.innerWidth < 768;
      var off = r.bottom < 0 || (mobile && r.top > window.innerHeight - 70);
      document.body.classList.toggle('mt-atc-past', off);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* 4. Product page: tapping the star rating scrolls to the reviews */
  function initStarLink() {
    var info = document.getElementById('product--page');
    if (!info) return;
    info.addEventListener('click', function (e) {
      var badge = e.target.closest('.jdgm-preview-badge, .jdgm-widget.jdgm-preview-badge, .product__review-stars');
      if (!badge) return;
      var target = document.getElementById('judgeme_product_reviews') ||
                   document.querySelector('.jdgm-review-widget, .jdgm-rev-widg, [data-widget-name="review_widget"]');
      if (!target) return;
      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  function initProduct() { initStickyGate(); initStarLink(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProduct);
  else initProduct();
  /* 5. Collection (mobile): put the Filter button next to Sort instead of floating over products */
  function initFilterButton() {
    var btn = document.querySelector('.filter__mobile--button');
    var bar = document.querySelector('.filter__bar');
    if (!btn || !bar || btn.dataset.mtMoved) return;
    btn.dataset.mtMoved = '1';
    btn.classList.add('mt-filter-btn');
    var count = btn.querySelector('.filter__mobile--current');
    if (count && (count.textContent.trim() === '0' || count.textContent.trim() === '')) count.setAttribute('data-zero', '');
    bar.insertBefore(btn, bar.firstChild);
  }

  /* 6. Cart (mobile): sticky checkout bar while the main checkout button is out of view */
  function initCartBar() {
    var form = document.querySelector('[data-mt-cart-form]');
    var main = form && form.querySelector('.mt-checkout-btn');
    if (!main) return;
    var totalEl = form.querySelector('.mt-cart__totalval .jsPrice');
    var bar = document.createElement('div');
    bar.className = 'mt-cartbar';
    bar.innerHTML = '<span class="mt-cartbar__total">Total<strong></strong></span><button type="button" class="mt-cartbar__btn">Checkout</button>';
    bar.querySelector('strong').textContent = totalEl ? totalEl.textContent.trim() : '';
    bar.querySelector('button').addEventListener('click', function () { main.click(); });
    document.body.appendChild(bar);
    var ticking = false;
    function check() {
      ticking = false;
      var r = main.getBoundingClientRect();
      var on = window.innerWidth < 768 && (r.top > window.innerHeight - 10 || r.bottom < 0);
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('mt-cartbar-on', on);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function initMobile() { initFilterButton(); initCartBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMobile);
  else initMobile();
})();